/**
 * 連携可能な外部サービスの情報を定義
 */

export type ServiceItem = {
  name: string;
  imageUrl: string;
  type: 'multi' | 'auth';
  sourceType: string;
  /** 特定の組織IDにのみ表示する場合に指定 */
  allowedOrganizationIds?: number[];
};

/**
 * 連携可能なサービス一覧
 * LinkedAccountSelectService と TrialAccountLinkStep1 で共通使用
 */
export const SERVICES: ServiceItem[] = [
  {
    name: 'HERP',
    imageUrl:
      'https://assets.st-note.com/production/uploads/images/95747076/profile_6db616f6488eeab0fe9fe59eadb5676f.png?fit=bounds&format=jpeg&quality=85&width=85',
    type: 'multi',
    sourceType: 'herp_agent',
  },
  {
    name: 'Talentio',
    imageUrl:
      'https://assets.talentio.com/assets/packs/media/src/assets/images/hire_logo-44617c2be2b09eeeeb62e951852e6190.png',
    type: 'multi',
    sourceType: 'talentio',
  },
  {
    name: 'HRMOS',
    imageUrl: 'https://d1larhalzuwzrz.cloudfront.net/q7uad6ay2rr0qbk3p3m91r0u2kla',
    type: 'multi',
    sourceType: 'hrmos',
  },
  {
    name: 'Circus AGENT',
    imageUrl: 'https://circus-job.com/static/images/circus-agent-logo.svg',
    type: 'auth',
    sourceType: 'circus_agent',
  },
  {
    name: 'Circus AGENT (RA)',
    imageUrl: 'https://circus-job.com/static/images/circus-agent-logo.svg',
    type: 'auth',
    sourceType: 'circus_agent_ra',
  },
  {
    name: 'Crowd Agent',
    imageUrl:
      'https://recruiting.crowd-agent.com/wp-content/themes/crowd-agent/assets/img/_logo/crowd-agent-h.svg',
    type: 'auth',
    sourceType: 'crowd_agent',
  },
  {
    name: 'ジョブカン',
    imageUrl: 'https://ats.jobcan.jp/static/images/logo.svg',
    type: 'multi',
    sourceType: 'jobcan',
  },
  {
    name: 'Zキャリア',
    imageUrl:
      'https://storage.googleapis.com/studio-design-asset-files/projects/EjOQAP04OJ/s-236x26_85ea80c8-203a-44d4-a9e7-9be307ff5621.svg',
    type: 'auth',
    sourceType: 'z_career',
  },
  {
    name: '採用一括かんりくん',
    imageUrl: 'https://www.career-cloud.asia/assets/img/lp/new2020/newlogo.png?1601807465',
    type: 'auth',
    sourceType: 'kanrikun',
  },
  {
    name: 'sonar ATS',
    imageUrl: 'https://sonar-ats.jp/wp-content/themes/indx/common/img/logo.svg',
    type: 'auth',
    sourceType: 'sonar',
  },
  {
    name: 'JoBins',
    imageUrl: 'https://jobins.jp/common/images/logo.svg',
    type: 'auth',
    sourceType: 'jobins',
  },
  {
    name: 'HITO-Link リクルーティング',
    imageUrl: 'https://www.hito-link.jp/hubfs/Rec/Hito_Link_Recruiting/logo_header_re.svg',
    type: 'auth',
    sourceType: 'hitolink_recruiting',
  },
  {
    name: 'HITO-Link AGENT',
    imageUrl: 'https://agent.hito-link.jp/_next/image?url=%2Flogin-logo.png&w=640&q=75',
    type: 'auth',
    sourceType: 'hitolink_agent',
  },
  {
    name: 'Wantedly Hire',
    imageUrl: 'https://hire.wantedly.com/_next/static/media/logo-wantedly.dcd288f9.svg',
    type: 'auth',
    sourceType: 'wantedly',
  },
  {
    name: 'PERSONA',
    imageUrl: 'https://www.agent.persona-ats.com/assets/persona_logo_blue-063f2708.png',
    type: 'auth',
    sourceType: 'persona',
  },
  {
    name: 'HireHub',
    imageUrl:
      'https://agent.hire-hub.io/assets/agent-logo-0ee88756ab6806e400885d1ef9a0e506bc1e8f092e54f2049b8b4f0fdda649d2.svg',
    type: 'auth',
    sourceType: 'hire_hub',
  },
  {
    name: 'キャリアバンク',
    imageUrl:
      'https://careerbank-jobsearch.com/wp-content/uploads/2020/10/%E3%82%AD%E3%83%A3%E3%83%AA%E3%82%A2%E3%83%90%E3%83%B3%E3%82%AF%E3%82%B8%E3%83%A7%E3%83%96%E3%82%B5%E3%83%BC%E3%83%81.png',
    type: 'auth',
    sourceType: 'career_bank',
  },
  {
    name: 'ジョブミル',
    imageUrl:
      'https://storage.googleapis.com/studio-design-asset-files/projects/NxqgEd5JW1/s-1693x234_78cd549f-12fb-4748-940d-f622cf9605e9.svg',
    type: 'auth',
    sourceType: 'jobmiru',
  },
  {
    name: 'ジョブミル（パートナー求人）',
    imageUrl:
      'https://storage.googleapis.com/studio-design-asset-files/projects/NxqgEd5JW1/s-1693x234_78cd549f-12fb-4748-940d-f622cf9605e9.svg',
    type: 'auth',
    sourceType: 'jobmiru_partner',
  },
  {
    name: 'JobSuite',
    imageUrl: 'https://jobsuite.jp/images/jobsuite.svg',
    type: 'auth',
    sourceType: 'jobsuite',
  },
  {
    name: 'AOL for Agent (2023)',
    imageUrl: 'https://saponet.mynavi.jp/pickup/aol/img/head/logo.png',
    type: 'auth',
    sourceType: 'aol_mpm',
  },
  {
    name: 'AOL for Agent (2024)',
    imageUrl: 'https://saponet.mynavi.jp/pickup/aol/img/head/logo.png',
    type: 'auth',
    sourceType: 'aol_mjn',
  },
  {
    name: 'AOL for Agent (2025)',
    imageUrl: 'https://saponet.mynavi.jp/pickup/aol/img/head/logo.png',
    type: 'auth',
    sourceType: 'aol_mbx',
  },
  {
    name: 'AOL for Agent (2026)',
    imageUrl: 'https://saponet.mynavi.jp/pickup/aol/img/head/logo.png',
    type: 'auth',
    sourceType: 'aol_mzw',
  },
  {
    name: 'RPM',
    imageUrl: 'https://www.tracom.co.jp/wp-content/uploads/2024/05/logo-1.jpg',
    type: 'auth',
    sourceType: 'rpm',
  },
  {
    name: 'DYM 採用管理システム',
    imageUrl: 'https://dym.asia/images/common/logo.svg',
    type: 'auth',
    sourceType: 'dym',
  },
  {
    name: 'レジュミー',
    imageUrl: 'https://resumee-hr.com/images/header-logo.svg',
    type: 'auth',
    sourceType: 'resumee',
  },
  {
    name: 'リクナビHRTech',
    imageUrl: 'https://ats.hrtech.rikunabi.com/dist/logo.png',
    type: 'auth',
    sourceType: 'rikunabi_hrtech',
  },
];

/**
 * 組織IDでサービスをフィルタリング
 */
export function filterServicesByOrganization(
  services: ServiceItem[],
  organizationId?: number
): ServiceItem[] {
  return services.filter((service) => {
    if (!service.allowedOrganizationIds) return true;
    return organizationId != null && service.allowedOrganizationIds.includes(organizationId);
  });
}
